export default theme => ({
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    backgroundColor: theme.palette.red.main,
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      height: 'initial',
      minHeight: '100%',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
      backgroundColor: theme.palette.red.main,
    },
  },
  background: {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  bgImg: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    background: `no-repeat url(${theme.url('/blocks/b10-bg.png')})`,
    backgroundSize: 'cover',
  },
  redRectangle: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    left: 0,
    height: '50%',
    width: '30%',
    background: theme.palette.red.main,
  },
  redCurve: {
    position: 'absolute',
    zIndex: 2,
    bottom: '60%',
    left: '75%',
    height: '40%',
    width: '25%',
    background: `no-repeat url(${theme.url('/blocks/b10-red-curve.svg')})`,
    backgroundSize: 'cover',
    backgroundPosition: 'left bottom',
  },
  greyCurveLeft: {
    position: 'absolute',
    zIndex: 2,
    top: '50%',
    right: '70%',
    height: '50%',
    width: '40%',
    background: `no-repeat url(${theme.url('/blocks/b10-grey-curve-left.svg')})`,
    backgroundSize: 'contain',
    backgroundPosition: 'right top',
  },
  greyCurveRight: {
    position: 'absolute',
    zIndex: 2,
    top: '50%',
    left: 'calc(30% - 2px)',
    height: '50%',
    width: '40%',
    background: `no-repeat url(${theme.url('/blocks/b10-grey-curve-right.svg')})`,
    backgroundSize: 'contain',
    backgroundPosition: 'left top',
  },
  blur: {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    left: '30%',
    background: 'rgba(255, 255, 255, 0)',
    backdropFilter: 'blur(12px)',
    height: '50%',
    width: '20%',
  },
  mainTitle: {
    zIndex: 2,
    position: 'absolute',
    top: '8%',
    left: '12%',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      bottom: 0,
      left: 0,
      textAlign: 'right',
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  content: {
    zIndex: 5,
    position: 'absolute',
    width: '100%',
    minWidth: 640,
    height: '100%',
    right: 0,
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      width: '100%',
      minWidth: 'initial',
      paddingBottom: theme.spacing(2),
    },
  },
  desc: {
    position: 'absolute',
    top: 0,
    left: '50%',
    width: '25%',
    height: '40%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      top: 0,
      left: 0,
      width: 'initial',
      padding: theme.spacing(4),
      margin: theme.spacing(2),
    },
  },
  main: {
    position: 'absolute',
    top: '40%',
    left: '50%',
    width: '50%',
    height: '60%',
    display: 'flex',
    backgroundColor: theme.palette.grey.light,
    padding: theme.spacing(4),
    '& > *': {
      width: '100%',
    },
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      top: 0,
      left: 0,
      width: 'initial',
      height: 'initial',
    },
  },
  article: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '&:first-child': {
      paddingBottom: theme.spacing(4),
    },
  },
  quote: {
    backgroundColor: theme.palette.grey.light,
    '& > *': {
      paddingBottom: theme.spacing(1),
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(4),
    },
  },
});
